export const NavChannel =  ()=>{
    return (
        <div className="collapse navbar-collapse" id="navbar-content">
        <a href="https://www.youtube.com/channel/UCOxE92CMGgvQ_Ec-Eo5v3xg">tcgcreator eternal betaを使ったtcg作成動画です</a>
        </div>
    )
}